import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { enterAnalyticsPage, leaveAnalyticsPage } from "../redux/navigationSlice";

const NavigationTracker = () => {
  const location = useLocation(); 
  const dispatch = useDispatch();

  function isBot() {
    if (typeof navigator === "undefined") return true; 

    if (window.location.hostname === "localhost" || 
      window.location.hostname === "127.0.0.1" || 
      window.location.hostname === "[::1]") {
    return false;
  }

    const botUserAgent = /headless|bot|crawler|spider|fetch|httpclient|python|java/i.test(
      navigator.userAgent || navigator.userAgentData?.brands?.map(b => b.brand).join(" ") || ""
    );

    const isHeadless = navigator.webdriver || !("onload" in new Image());

    return botUserAgent || isHeadless;
  }

  // Normal function outside useEffect to send analytics
  function sendAnalyticsBeacon(analyticsEvent) {
    const url = "/api/realtime-analytics";
    const data = JSON.stringify(analyticsEvent);

    const getLocalStorageItem = (key) => {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        console.warn("localStorage blocked", e);
        return undefined;
      }
    };

    const userAddress = getLocalStorageItem("userAddress") || undefined;
    const selectedNetwork = getLocalStorageItem("selectedNetwork") || "mainnet";

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-User-Address": userAddress || "",  // Include if available
          "X-Network": selectedNetwork || "mainnet",  // Default to mainnet if not selected
        },
        credentials: "include",
        body: data,
      })

        .then((response) => {
          if (!response.ok) {
            //console.error("Fallback fetch failed:", response.status, response.statusText);
          } else {
            //console.log("Fallback fetch successful");
          }
        })
        .catch((error) => console.error("Fallback fetch error:", error));
    } 

  useEffect(() => {

    if (isBot()) {
      //console.log("Bot detected, skipping analytics.");
      return;
    }

    const currentPath = location.pathname;
    const referringUrl = document.referrer || "direct";

    let loadTime = 0;

    const navigationTiming = performance.getEntriesByType("navigation")[0] || performance.timing;

    if (navigationTiming) {
      loadTime = (navigationTiming.loadEventEnd - navigationTiming.startTime).toFixed(2);
      loadTime = isNaN(loadTime) ? 0 : parseFloat(loadTime);
    }

    //console.log("Accurate load time (ms):", loadTime);

    const analyticsEvent = {
      type: "analytics",
      page: currentPath || "/",
      timestamp: new Date().toISOString(),
      referringUrl,
      loadTime,
      screenWidth: window.screen.width || 0,
      screenHeight: window.screen.height || 0,
    };

    // Track analytics page state
    if (
      location.pathname === "/analytics" ||
      location.pathname === "/analytic"
    ) {
      dispatch(enterAnalyticsPage());
    } else {
      dispatch(leaveAnalyticsPage()); 
    }

      sendAnalyticsBeacon(analyticsEvent);  

      //console.log("Initial analytics sent:", analyticsEvent);
    
  }, [location.pathname, dispatch,]);

  return null;
};

export default NavigationTracker;
